import { __decorate } from "tslib";
import { EventEmitter, Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { ApiWorkflowConstants } from "../../shared/constants/api-constants/api-workflow.constants";
import { ApiNotesConstants } from "../../shared/constants/api-constants/api-notes.constants";
import { ApiAttachmentConstants } from "../../shared/constants/api-constants/api-attachment.constants";
import { ApiSurvey123Constants } from "../../shared/constants/api-constants/api-survey-123.constants";
import { map } from "rxjs/operators";
import { ApiAssessmentConstants } from "../../shared/constants/api-constants/api-assessment.constants";
import { ApiLookupConstants } from "../../shared/constants/api-constants/api-lookup.constants";
import { ApiStepMetaConstants } from "../../shared/constants/api-constants/api-step-meta.constants";
import { TrueCentroidResultsModel } from "../../shared/models/gpserver-truecentroid-model";
import { ApiSolvemDocumentSigningConstants } from "../../shared/constants/api-constants/api-solvem-document-signing.constants";
import { ApiCloseoutConstants } from "../../shared/constants/api-constants/api-closeout.constants";
import { ApiOrganisationConstants } from "../../shared/constants/api-constants/api-organisation.constants";
import { ApiModuleConstants } from "../../shared/constants/api-constants/api-module.constants";
import { ApiStampsConstants } from "../../shared/constants/api-constants/api-stamps.constants";
import { UrlParameterEncodingCodec } from "../../shared/classes/url-parameter-encoding-codec";
import { ApiPropertyValuationValuationBlockConstants } from "../../shared/constants/api-constants/api-property-valuation-valuation-block.constants";
import { ApiAdminConstants } from "../../shared/constants/api-constants/api-admin.constants";
import { ApiModuleMapConstants } from "../../shared/constants/api-constants/api-module-map.constants";
import { AuthService } from "../../shared/services/auth/auth.service";
import { ApiTimeoutConstants } from "src/app/shared/constants/api-constants/api-timeout.constants";
import { ApiTeamConstants } from "../../shared/constants/api-constants/api-team.constants";
import { ApiBuildingPlansInspectorateConstants } from "../../shared/constants/api-constants/api-building-plans-inspectorate.constants";
import { ApiScheduledReminderConstants } from "../../shared/constants/api-constants/api-scheduled-reminder.constants";
import { ApiModuleSettingConstants } from "../../shared/constants/api-constants/api-module-setting.constants";
import { ApiUserConstants } from "src/app/shared/constants/api-constants/api-user.constants";
import { ApiCommentsConstants } from "../../shared/constants/api-constants/api-comments.constants";
let ViewApplicationService = class ViewApplicationService {
    http;
    authService;
    params;
    getCurrentStepEvent = new EventEmitter();
    viewApplicationMenuLinks;
    viewSurveyAttachmentCount = new BehaviorSubject(0);
    currentAttachmentCount = this.viewSurveyAttachmentCount.asObservable();
    updateTrackerSubject = new BehaviorSubject(true);
    updateTrackerObservable = this.updateTrackerSubject.asObservable();
    currentTitlesBehavior = new BehaviorSubject(null);
    $currentTitlesObservable = this.currentTitlesBehavior.asObservable();
    constructor(http, authService) {
        this.http = http;
        this.authService = authService;
    }
    setViewApplicationMenuLinks(linkHeadings) {
        this.viewApplicationMenuLinks = linkHeadings;
    }
    getAdHocMoveToWorkflowStepObservable(params) {
        return this.http.post(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_AD_HOC_MOVE_TO_WORKFLOW_STEP, params);
    }
    getNotesPostObservable(params) {
        return this.http.post(ApiNotesConstants.URL, params);
    }
    getIsClassicWorkflow() {
        return this.http.get(`${ApiAdminConstants.URL}/${ApiAdminConstants.FUNCTION_IS_CLASSIC_WORKFLOW}`);
    }
    getNotesDeleteObservable(noteId) {
        return this.http.delete(`${ApiNotesConstants.URL}/${noteId}`);
    }
    deleteMultipleAttachments(request) {
        return this.http.post(`${ApiAttachmentConstants.URL}/${ApiAttachmentConstants.FUNCTION_DELETE_MULTIPLE_ATTACHMENTS}`, request);
    }
    setShowHideCommentsInAFLAPortal(request) {
        return this.http.post(`${ApiCommentsConstants.URL}/${ApiCommentsConstants.FUNCTION_SET_SHOW_HIDE_COMMENTS_IN_PORTAL}`, request);
    }
    enableAttachmentInAFLAPortal(request) {
        return this.http.post(`${ApiAttachmentConstants.URL}/${ApiAttachmentConstants.FUNCTION_ENABLE_AFLA_PORTAL_ATTACHMENTS}`, request);
    }
    disableAttachmentInAFLAPortal(request) {
        return this.http.post(`${ApiAttachmentConstants.URL}/${ApiAttachmentConstants.FUNCTION_DISABLE_AFLA_PORTAL_ATTACHMENTS}`, request);
    }
    getAttachmentContentObservable(attachmentId) {
        return this.http.get(`${ApiAttachmentConstants.URL}/${attachmentId}/${ApiAttachmentConstants.FUNCTION_GET_ATTACHMENT_CONTENT}`, { responseType: "blob" });
    }
    getWorkflowJobTrackerDataObservable(params) {
        return this.http.get(`${ApiWorkflowConstants.URL}/${ApiWorkflowConstants.FUNCTION_GET_JOB_TRACKER_DATA}`, { params });
    }
    getJobWorkflowImageObservable(moduleId, jobId) {
        return this.http.get(`${ApiWorkflowConstants.URL}/${ApiWorkflowConstants.FUNCTION_GET_JOB_WORKFLOW_IMAGE}?moduleId=${moduleId}&jobId=${jobId}`, { responseType: "blob" });
    }
    getSurveysForApplication(moduleId, jobId) {
        return this.http.get(`${ApiSurvey123Constants.URL}/${ApiSurvey123Constants.FUNCTION_GET_ALL_SURVEYS}?moduleId=${moduleId}&jobId=${jobId}`).pipe(map(surveyResultList => {
            return surveyResultList;
        }));
    }
    getAssessmentsForApplication(jobId, expand, orderBy) {
        const params = {
            $filter: `jobId eq ${jobId}`,
            $expand: expand
        };
        return this.http.get(ApiAssessmentConstants.URL, { params }).pipe(map(assessmentList => {
            return assessmentList;
        }));
    }
    getSurveyWithData(moduleId, jobId, surveyId) {
        return this.http.get(`${ApiSurvey123Constants.URL}/${ApiSurvey123Constants.FUNCTION_GET_SURVEY_DATA}?moduleId=${moduleId}&jobId=${jobId}&surveyId=${surveyId}`).pipe(map(surveyResultList => {
            return surveyResultList;
        }));
    }
    // we can only load the attachments after they have all been retrieved - we use this shared-services to track the no. of attachments that are still loading
    changeLoadingAttachmentCount(loadingCount) {
        this.viewSurveyAttachmentCount.next(loadingCount);
    }
    getLookupsObservable(params) {
        return this.http.get(ApiLookupConstants.URL, { params }).pipe(map(lookups => {
            return lookups;
        }));
    }
    getApplicationObservable(url, params) {
        return this.http.get(url, { params }).pipe(map(applications => {
            return applications;
        }));
    }
    getApplicationSaveObservable(url, applicationId, application) {
        return this.http.patch(`${url}/${applicationId}`, application)
            .pipe(map(response => {
            return response;
        }));
    }
    getApplicationSaveApplicantObservable(url, setApplicantAndApplicantAgentAction, applicationId, params) {
        return this.http.post(`${url}/${applicationId}/${setApplicantAndApplicantAgentAction}`, params)
            .pipe(map(response => {
            return response;
        }));
    }
    // TODO - Lawrence - Confirm with Matthew that this should be here.
    getApplicationSavePremisesObservable(url, params) {
        return this.http.post(`${url}`, params)
            .pipe(map(response => {
            return response;
        }));
    }
    deleteApplicantFromApplicationObservable(url, setApplicantAgentAction, applicationId) {
        return this.http.post(`${url}/${applicationId}/${setApplicantAgentAction}`, {}).pipe(map(response => {
            return response;
        }));
    }
    getStepMetaObservable(params) {
        return this.http.get(ApiStepMetaConstants.URL, { params });
    }
    getTrueCentroid(url, params) {
        return this.http.post(url, params).pipe(map((response) => {
            return new TrueCentroidResultsModel().deserialize(response);
        }));
    }
    stampDocument(request) {
        return this.http.post(`${ApiAttachmentConstants.URL}/${ApiAttachmentConstants.FUNCTION_STAMP_DOCUMENT}`, request);
    }
    getSolveMDocumentSign(moduleId, jobId, attachmentId, returnUrl) {
        const params = `moduleId=${moduleId}&jobId=${jobId}&attachmentId=${attachmentId}&returnUrl=${encodeURIComponent(returnUrl)}`;
        return this.http.get(`${ApiSolvemDocumentSigningConstants.URL}/${ApiSolvemDocumentSigningConstants.FUNCTION_GET_DOCUMENT_SIGNING_URL}?${params}`);
    }
    getCloseout(params) {
        return this.http.get(ApiCloseoutConstants.URL, { params }).pipe(map((data) => {
            return data.value;
        }));
    }
    nextTitles(titles) {
        this.currentTitlesBehavior.next(titles);
    }
    updateTracker() {
        this.updateTrackerSubject.next(true);
    }
    getOrganisations(params) {
        return this.http.get(ApiOrganisationConstants.URL, { params });
    }
    getModule(moduleId, params) {
        return this.http.get(`${ApiModuleConstants.URL}/${moduleId}`, { params });
    }
    getAttachmentContentBase64Observable(attachmentId) {
        return this.http.get(`${ApiAttachmentConstants.URL}/${attachmentId}/${ApiAttachmentConstants.FUNCTION_GET_ATTACHMENT_CONTENT_BASE_64}`);
    }
    getStampContentBase64Observable(stampId, date, myName, referenceNumber) {
        const codec = new UrlParameterEncodingCodec();
        date = codec.encodeKey(date);
        referenceNumber = codec.encodeKey(referenceNumber);
        myName = codec.encodeKey(myName);
        return this.http.get(`${ApiStampsConstants.URL}/${stampId}/${ApiStampsConstants.FUNCTION_GET_STAMP_CONTENT_BASE64}?date=${date}&myName=${myName}&referenceNumber=${referenceNumber}`);
    }
    getSignatureContentBase64Observable(userId, moduleId) {
        const params = {
            moduleId
        };
        return this.http.get(`${ApiUserConstants.URL}/${userId}/${ApiUserConstants.FUNCTION_GET_SIGNATURE_CONTENT_BASE64}`, { params });
    }
    getModuleStamps(moduleId) {
        return this.http.get(`${ApiModuleConstants.URL}/${moduleId}/${ApiModuleConstants.FUNCTION_GET_MODULE_STAMPS}`).pipe(map((data) => {
            return data.value;
        }));
    }
    getDownloadPdfStampBase64(moduleId) {
        return this.http.get(`${ApiModuleConstants.URL}/${moduleId}/${ApiModuleConstants.FUNCTION_DOWNLOAD_MODULE_STAMP_BASE_64}`);
    }
    GetMNDAttachmentConsolidatedPDFReport(moduleId, jobId) {
        return this.http.get(`${ApiAttachmentConstants.URL}/${jobId}/${ApiAttachmentConstants.FUNCTION_GET_MND_ATTACHMENT_COLSOLIDATED_PDF_REPORT}?moduleId=${moduleId}`, { responseType: "blob" });
    }
    getSurveyAttachments(params) {
        return this.http.get(`${ApiAttachmentConstants.URL}`, { params });
    }
    getAssistantValuers(key) {
        return this.http.post(`${ApiPropertyValuationValuationBlockConstants.URL}/${key}/${ApiPropertyValuationValuationBlockConstants.FUNCTION_GET_ASSISTANT_VALUERS}`, {});
    }
    getDataCollectors(key) {
        return this.http.post(`${ApiPropertyValuationValuationBlockConstants.URL}/${key}/${ApiPropertyValuationValuationBlockConstants.FUNCTION_GET_DATA_COLLECTORS}`, {});
    }
    postUpgradeClassicWorkflow(moduleId, jobId) {
        return this.http.post(`${ApiAdminConstants.URL}/${ApiAdminConstants.FUNCTION_UPGRADE_APPLICATION_WORKFLOW}?moduleId=${moduleId}&jobId=${jobId}`, {});
    }
    getApplicationTeam(params) {
        return this.http.get(`${ApiTeamConstants.URL}`, { params });
    }
    getApplicationTeamUserRoles(jobId, params) {
        return this.http.get(`${ApiTeamConstants.URL}/${jobId}/${ApiTeamConstants.FUNCTION_GET_APPLICATION_TEAM_USER_ROLES}`, { params });
    }
    getResponsiblePersons(params) {
        return this.http.post(`${ApiTeamConstants.URL}/${ApiTeamConstants.FUNCTION_GET_RESPONSIBLE_PERSONS}`, params).pipe(map(response => {
            return response;
        }));
    }
    postUpdateApplicationTeam(key, params) {
        return this.http.patch(`${ApiTeamConstants.URL}/${key}`, params);
    }
    postSaveApplicationTeam(params) {
        return this.http.post(`${ApiTeamConstants.URL}`, params);
    }
    postBulkUpdateTeam(params) {
        return this.http.post(`${ApiTeamConstants.URL}/${ApiTeamConstants.FUNCTION_BULK_REASSIGN_TEAM_MEMBER}`, params)
            .pipe(map(response => {
            return response;
        }));
    }
    postUpdateTimeoutTimer(key, params) {
        return this.http.post(`${ApiTimeoutConstants.URL}/${key}/${ApiTimeoutConstants.UpdateTimeoutTimer}`, params);
    }
    postContinueTimeoutTimers(params) {
        return this.http.post(`${ApiTimeoutConstants.URL}/${ApiTimeoutConstants.FUNCTION_POST_CONTINUE_TIMEOUT_TIMER}`, params);
    }
    postPauseTimeoutTimers(params) {
        return this.http.post(`${ApiTimeoutConstants.URL}/${ApiTimeoutConstants.FUNCTION_POST_PAUSE_TIMEOUT_TIMER}`, params);
    }
    getScheduledReminders(params) {
        return this.http.get(`${ApiScheduledReminderConstants.URL}`, { params });
    }
    postUpdateScheduledReminder(key, params) {
        return this.http.post(`${ApiScheduledReminderConstants.URL}/${key}/${ApiScheduledReminderConstants.UpdateScheduledReminder}`, params);
    }
    sendMissingLookupsEmail(params) {
        return this.http.post(`${ApiModuleConstants.URL}/${ApiModuleConstants.MISSING_LOOKUP_EMAIL_REQUEST_URL}`, params)
            .pipe(map(response => {
            return response;
        }));
    }
    getModuleMaps(moduleId) {
        const params = {
            $filter: `moduleId eq ${moduleId}`,
            $orderby: "mapOrder desc"
        };
        return this.http.get(ApiModuleMapConstants.URL, { params });
    }
    queryMapViaProxy(url, moduleMapId) {
        const params = {
            MapServiceId: moduleMapId, Authorization: this.authService.getAuthToken()
        };
        // @ts-ignore
        return this.http.get(url, { headers: params });
    }
    getModuleSettings(params) {
        return this.http.get(ApiModuleSettingConstants.URL, { params });
    }
    getBpiBpLinkedApplications(params) {
        return this.http.post(`${ApiBuildingPlansInspectorateConstants.URL}/${ApiBuildingPlansInspectorateConstants.FUNCTION_GET_LINK_BP_APPLICATION}`, params);
    }
    postBpiLinkBpApplications(params) {
        return this.http.post(`${ApiBuildingPlansInspectorateConstants.URL}/${ApiBuildingPlansInspectorateConstants.FUNCTION_LINK_BP_APPLICATION}`, params);
    }
    postBpiDelinkedApplications(params) {
        return this.http.post(`${ApiBuildingPlansInspectorateConstants.URL}/${ApiBuildingPlansInspectorateConstants.FUNCTION_DELINK_BP_APPLICATION}`, params);
    }
    getAllApplicationsMapService(moduleId, organisationId) {
        const params = {
            $filter: `selectionLayerType eq 'All applications' and (moduleId eq ${moduleId} or (moduleId eq null and organisationId eq ${organisationId}))`,
            $orderby: "mapOrder desc"
        };
        return this.http.get(ApiModuleMapConstants.URL, { params });
    }
    withdrawApplication(params) {
        return this.http.post(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_WITHDRAW_APPLICATION, params);
    }
    static ctorParameters = () => [
        { type: HttpClient },
        { type: AuthService }
    ];
};
ViewApplicationService = __decorate([
    Injectable({
        providedIn: "root"
    })
], ViewApplicationService);
export { ViewApplicationService };
